import { Alert, AlertDescription, AlertIcon, AlertTitle, Button, Divider, FormControl, FormLabel, Input, InputGroup, InputLeftElement, InputRightElement, Select, Stack } from "@chakra-ui/react";
import AutoComplete from "components/autocomplete/AutoComplete";
import Card from "components/card";
import { useEffect, useState } from "react";
import { FaCheck, FaTrash } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { message } from "utils/Funciones";
import { currencyFormat } from "utils/Funciones";

function TableCartItemsDetalles({ data }) {

    return (
        <Card extra="w-full h-full sm:overflow-x-auto">
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left rtl:text-right text-navy-500 dark:text-navy-400">
                    <thead class="text-xs text-navy-900 uppercase bg-navy-50 dark:bg-navy-700 dark:text-navy-200">
                        <tr>
                            <th scope="col" className="px-7 py-3">
                                <span class="sr-only">Image</span>
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Código
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Producto
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Cantidad
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Precio unitario
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Total
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.cartItems.length > 0 ? (

                                data.cartItems.map((item, idx) => (
                                    <tr key={idx} class="bg-white border-b dark:bg-navy-900 dark:border-navy-700 hover:bg-navy-200 dark:hover:bg-navy-600">
                                        <td class="p-4">
                                            <LazyLoadImage
                                                className="object-cover min-w-[45px] min-h-[45px] max-w-[45px] max-h-[45px] rounded-lg"
                                                alt={`No image`}
                                                effect="black-and-white"
                                                src={`/images/productos/${item.product.imagen}`}
                                            />
                                        </td>
                                        <td class="px-6 py-4 font-semibold text-navy-900 dark:text-white">
                                            {item.product.codigointerno}
                                        </td>
                                        <td class="px-6 py-4 font-semibold text-navy-900 dark:text-white">
                                            {item.product.name}
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex items-center gap-2">
                                                <div>
                                                    <Input isReadOnly={true} name="quantity" value={item.quantity} type="number" className="ml-1 flex !h-12 !w-12 items-center justify-center !rounded-xl border bg-lightPrimary dark:bg-navy-900 p-3 text-sm ring-2 focus:ring-brand-500 focus:border-brand-500 dark:focus:ring-brand-400 dark:focus:border-brand-400 outline-none border-gray-200 dark:!border-white/10 dark:text-white" />
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-6 py-4 font-semibold text-navy-900 dark:text-white">
                                            {currencyFormat(item.price)}
                                        </td>
                                        <td class="px-6 py-4 font-semibold text-navy-900 dark:text-white">
                                            {currencyFormat(item.price * item.quantity)}
                                        </td>
                                    </tr>
                                ))
                            ) :
                                (
                                    <tr>
                                        <td colSpan={7}>
                                            <Alert
                                                variant='subtle'
                                                flexDirection='column'
                                                alignItems='center'
                                                justifyContent='center'
                                                textAlign='center'
                                                height='110px'
                                                status='error'
                                            >
                                                <AlertIcon boxSize='40px' mr={0} />
                                                <AlertDescription maxWidth='sm' fontSize={17}>
                                                    Hay un error, este carrito no tiene productos
                                                </AlertDescription>
                                            </Alert>
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </table>
            </div>

            <div className="mt-5 flex flex-wrap gap-4">
                <FormControl className="!w-full md:!w-3/12 !mb-3 !p-2">
                    <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-bold">Descuento</FormLabel>
                    <InputGroup>
                        <InputLeftElement className="mt-[3px] ml-1 text-black dark:text-white" pointerEvents='none' fontSize='1em'>
                            PEN
                        </InputLeftElement>

                        <Input isReadOnly={true} name="descuento" value={data.descuento} type="number" className="ml-1 flex !h-12 !w-44 items-center justify-center !rounded-xl border bg-lightPrimary dark:bg-navy-900 p-3 text-sm ring-2 focus:ring-brand-500 focus:border-brand-500 dark:focus:ring-brand-400 dark:focus:border-brand-400 outline-none border-gray-200 dark:!border-white/10 dark:text-white" />
                    </InputGroup>
                </FormControl>
                <FormControl className="!w-full md:!w-3/12 !mb-3 !p-2">
                    <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-bold">Método de pago</FormLabel>
                    <Input isReadOnly={true} name="metodopago" value={data.metodopago} type="text" className="ml-1 flex !h-12 !w-44 items-center justify-center !rounded-xl border bg-lightPrimary dark:bg-navy-900 p-3 text-sm ring-2 focus:ring-brand-500 focus:border-brand-500 dark:focus:ring-brand-400 dark:focus:border-brand-400 outline-none border-gray-200 dark:!border-white/10 dark:text-white" />
                </FormControl>
            </div>
            <div className="mt-5 flex flex-wrap gap-4">
                <div className="flex items-center justify-end w-full mt-5 md:mt-0">
                    <div className="w-64 shadow-lg shadow-shadow-500 dark:shadow-none font-semibold">
                        RESUMEN
                    </div>
                </div>
                <div className="flex items-center justify-end w-full mt-5 md:mt-0">
                    <div className="w-64 shadow-lg shadow-shadow-500 dark:shadow-none">
                        Ope. Gravada : {data.cartItems?.length > 0 ? currencyFormat((data.total / 1.18)) : 0}
                    </div>
                </div>
                <div className="flex items-center justify-end w-full">
                    <div className="w-64 shadow-lg shadow-shadow-500 dark:shadow-none">
                        I.G.V (18%) : {data.cartItems?.length > 0 ? currencyFormat((data.total - (data.total / 1.18))) : 0}
                    </div>
                </div>
                {data.descuento > 0 &&
                    <div className="flex items-center justify-end w-full mb-5">
                        <div className={`w-64 shadow-lg shadow-shadow-500 dark:shadow-none`}>
                            Otros DSCTO : {currencyFormat(data.descuento)}
                        </div>
                    </div>
                }
                <div className="flex items-center justify-end w-full mb-5">
                    <div className={`w-64 shadow-lg shadow-shadow-500 dark:shadow-none text-lg font-semibold ${data.descuento > 0 && '!text-red-500'}`}>
                        Importe total : {data.cartItems?.length > 0 ? currencyFormat((data.total - data.descuento)) : 0}
                    </div>
                </div>
            </div>
        </Card >
    )
}

export default TableCartItemsDetalles